<div (click)="openPopup($event)" tappable>{{ value | durationTime }}</div>
